import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/email-blacklist";

// All admin-only.
const getAll = () => axios.get(API_URL, { headers: authHeader() });

// data: { pattern, type: "wildcard" | "regex", note? }
const create = (data) => axios.post(API_URL, data, { headers: authHeader() });

const remove = (id) => axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const test = (email) =>
  axios.post(`${API_URL}/test`, { email }, { headers: authHeader() });

const EmailBlacklistService = { getAll, create, remove, test };

export default EmailBlacklistService;
